import React from 'react';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';
import { setCurrentProjectAsync } from '../../../redux/project/Actions';


import {
    Button,
    Divider,
    Modal,
    Paper,
    Typography,
    Badge,
    IconButton,
    makeStyles,
    useMediaQuery,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent
} from '@material-ui/core';

import FolderIcon from '@material-ui/icons/Folder';
import CheckIcon from '@material-ui/icons/Check';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { NewFolder } from '../Icons';
import ScrollableContainer from '../../utility/ScrollableContainer';
import ProjectFilterTextField from './ProjectFilterTextField';
import { useState } from 'react';
import { useTheme } from '@material-ui/styles';
import ProjectItem from './ProjectItem';
import NewProjectModal from './NewProjectModal';
import EditProjectModal from './EditProjectModal';
import DeleteProjectModal from './DeleteProjectModal';
import DialogButton from '../../Common/UI/Dialog/DialogButton';

const useStyles = makeStyles((theme) => styles(theme));

const propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

const defaultProps = {

};


function ProjectListModal ({ isOpen, onClose }) {
    const classes = useStyles();

    const dispatch = useDispatch();
    const dispatchSetCurrentProjectAsync = (id) => dispatch(setCurrentProjectAsync(id));
    const currentProject = useSelector(state => state.project.currentProject);
    const projects = useSelector(state => state.project.projects);
    const userId = useSelector(state => state.user.id);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const [newProjectOpen, setNewProjectOpen] = useState(false);
    const [selectedProjectId, setSelectedProjectId] = useState((currentProject && currentProject.id != null) ? currentProject.id : null);
    const [editingProjectId, setEditingProjectId] = useState(null);
    const [deletingProjectId, setDeletingProjectId] = useState(null);
    const [filter, setFilter] = useState('');

    function setCurrentProject () {
        dispatchSetCurrentProjectAsync(selectedProjectId);
        setSelectedProjectId(null);
        onClose(false);
    }

    function openNewModal(isOpen) {
        setNewProjectOpen(isOpen);
    }

    function openEditModal(projectId) {
        setEditingProjectId(projectId);
    }

    function openDeleteModal(projectId) {
        setDeletingProjectId(projectId);
    }

    return (
        <>
            <Dialog
                open={Boolean(isOpen) && (!newProjectOpen) && editingProjectId == null && deletingProjectId == null}
                onClose={onClose}
                fullScreen={fullScreen}
                maxWidth="md"
            >
                <DialogTitle disableTypography>
                    <FolderIcon />
                    <Typography
                        variant="h4"
                    >
                        My Projects
                    </Typography>
                    <ProjectFilterTextField
                        filter={filter}
                        onFilterChange={setFilter}
                    />
                </DialogTitle>
                <DialogContent dividers classes={{ root: classes.scrollable }}>
                    <div className={classes.projectGrid}>
                        <div
                            className={classes.createProject}
                            onClick={() => openNewModal(true)}
                        >
                            <div className={classes.createProjectContent}>
                                <NewFolder />
                                <Typography
                                    variant="body1"
                                >
                                    New project
                                </Typography>
                            </div>
                        </div>
                        { 
                            projects
                                .filter(project => project.name.toLowerCase().includes(filter.toLowerCase()))
                                .map((project) => {
                                    return (
                                        <ProjectItem
                                            key={project.id}
                                            project={project}
                                            isOwner={userId === project.createdById}
                                            isCurrentProject={project.id === currentProject.id}
                                            isSelectedProject={project.id === selectedProjectId}
                                            onClick={setSelectedProjectId}
                                            onEditClick={openEditModal}
                                            onDeleteClick={openDeleteModal}
                                        />
                                    );
                                })
                        }
                    </div>
                </DialogContent>
                <DialogActions>
                    <DialogButton
                        variant="contained"
                        disabled={!selectedProjectId || selectedProjectId === currentProject.id}
                        onClick={setCurrentProject}
                    >
                        OPEN PROJECT
                    </DialogButton>
                    <DialogButton
                        variant="outlined"
                        onClick={onClose}
                    >
                        CLOSE
                    </DialogButton>
                </DialogActions>
            </Dialog>
            <NewProjectModal
                open={newProjectOpen}
                onClose={() => openNewModal(false)}
            />
            <EditProjectModal
                open={Boolean(editingProjectId)}
                onClose={() => openEditModal(null)}
                id={editingProjectId}
            /> 
            {/* Adding the if case to be able to rerender the modal triggering the componentDidMount */}
            {Boolean(deletingProjectId) && <DeleteProjectModal
                open={Boolean(deletingProjectId)}
                onClose={() => openDeleteModal(null)}
                id={deletingProjectId}
            />}
        </>
    );
    
}

const styles = theme => ({
    scrollable: {
        ...theme.components.scrollable
    },
    projectGrid: {
        display: 'grid',
        gridTemplateColumns: '170px 170px 170px',
        gridGap: '30px'
    },
    createProject: {
        border: `1px solid ${theme.palette.grey.variant3}`,
        width: '170px',
        height: '170px',
        borderRadius: theme.constants.radius.sm,
        cursor: 'pointer',
        display: 'grid',
        placeItems: 'center'
    },
    createProjectContent: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: '20px',
        alignItems: 'center'
    },
    button: {
        width: '150px',
        height: '35px',
        letterSpacing: '1.25px'
    }
});

ProjectListModal.propTypes = propTypes;
ProjectListModal.defaultProps = defaultProps;

export default ProjectListModal;